import { render, staticRenderFns } from "./FaqDrawer.vue?vue&type=template&id=c4854eb6"
import script from "./FaqDrawer.vue?vue&type=script&lang=js"
export * from "./FaqDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports